import { PaginationProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { useCallback, useState } from 'react';
import { orderList, OrderListParams } from 'services/api/pay';

function useOrder() {
  const [page, setPage] = useState<PaginationProps>({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const res = useCrud({
    readList: useCallback((params: OrderListParams) => {
      return orderList(params).then((res) => {
        const {
          pageInfo: { pageNo: current, pageSize, total },
          orderInfos,
        } = res;

        setPage({
          current,
          pageSize,
          total,
        });

        return orderInfos;
      });
    }, []),
  });

  return {
    ...res,
    page,
    setPage,
  };
}

export default useOrder;
